import { State } from 'reactApp/modules/welcome/welcome.types';
import { RootState } from 'reactApp/store';

const getWelcomeState = (state: RootState) => state.welcome as State;

export const isWelcomePromoShow = (state: RootState): boolean => getWelcomeState(state).isShow;
